module.exports = __webpack_public_path__ + "static/media/reader-outline.5dbe362c.png";